import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { GetTaskListPayload, TaskList } from '@nx-frontend/shared/types';

export async function getTaskList({ userId, workspaceId, taskListId }: GetTaskListPayload): Promise<TaskList | null> {
  try {
    const host = generalEnv.taskServiceUrl;
    const response = await axiosClient.get<TaskList>(`${host}/v1/workspaces/${workspaceId}/taskLists/${taskListId}`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    return response.data;
  } catch (err) {
    console.log(`getTaskList error: ${err}`);
  }
  return null;
}
